import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const BoardingSegmentDurationTooltipContentStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "boarding-segment-duration-tooltip",
  },
)`
  width: 280px;
  max-width: 70vw;
  white-space: normal;
  line-height: 1.45;
  text-align: start;

  p {
    margin: 0 0 6px;
    white-space: normal;
    overflow-wrap: break-word;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .boarding-segment-duration-tooltip__title {
    font-weight: 600;
  }
`;
